import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import httpAdapterInstance from "configs/HttpAdapterConfig";
import { AdminApiEndpoints } from "shared/ApiEndpoints";
import { ApiStates } from "shared/constants";
// Initial state
const initialCandidateState = {
  fetchingCandidateDetails: ApiStates.idle,
  updatingCandidateDetails: ApiStates.idle,
  updateCandidateResponse: "",
  candidateDetails: {},
  fetchingCandidateTraits: ApiStates.idle,
  candidateTraits: [],
  fetchCandidateAppliedJobs: ApiStates.idle,
  candidateAppliedJobs : [],
};
export const fetchCandidateDetails = createAsyncThunk(
    "fetchCandidateDetails",
    async ({ candidateId }, { rejectWithValue }) => {
      return await httpAdapterInstance
        .get(`${AdminApiEndpoints.ADMIN_CANDIDATE}/${candidateId}`)
        .then((response) => response?.data)
        .catch((error) => {
          throw rejectWithValue(error.response?.data);
        });
    }
  );
  export const updateCandidateDetails = createAsyncThunk(
    "updateCandidateDetails",
    async ({ candidateId, formData }, { rejectWithValue }) => {
      return await httpAdapterInstance
        .put(`${AdminApiEndpoints.ADMIN_CANDIDATE}/${candidateId}`, formData)
        .then((response) => response?.data)
        .catch((error) => {
          throw rejectWithValue(error.response?.data);
        });
    }
  );
  export const fetchCandidateTraits = createAsyncThunk(
    "fetchCandidateTraits",
    async ({ candidateId }, { rejectWithValue }) => {
      return await httpAdapterInstance
        .get(`${AdminApiEndpoints.ADMIN_CANDIDATE}/${candidateId}/traits`)
        .then((response) => response?.data)
        .catch((error) => {
          throw rejectWithValue(error.response?.data);
        });
    }
  );

  export const fetchCandidateAppliedJobs = createAsyncThunk(
    "fetchCandidateAppliedJobs",
    async ({ candidateId }, { rejectWithValue }) => {
      return await httpAdapterInstance
        .get(
          `${AdminApiEndpoints.ADMIN_CANDIDATE}/${candidateId}/job/applications`
        )
        .then((response) => response?.data)
        .catch((error) => {
          throw rejectWithValue(error.response?.data);
        });
    }
  );

// Slice
const candidateDetailsSlice = createSlice({
  name: "candidate",
  initialState: initialCandidateState,
  reducers: {
    resetCandidateUpdateState: (state) => {
      state.updatingCandidateDetails = ApiStates.idle;
      state.updateCandidateResponse = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCandidateDetails.pending, (state) => {
      state.fetchingCandidateDetails = ApiStates.pending;
    });
    builder.addCase(fetchCandidateDetails.fulfilled, (state, action) => {
      state.candidateDetails = action?.payload;
      state.fetchingCandidateDetails = ApiStates.success;
    });
    builder.addCase(fetchCandidateDetails.rejected, (state) => {
      state.candidateDetails = {};
      state.fetchingCandidateDetails = ApiStates.failed;
    });
    builder.addCase(updateCandidateDetails.pending, (state) => {
      state.updatingCandidateDetails = ApiStates.pending;
    });
    builder.addCase(updateCandidateDetails.fulfilled, (state, action) => {
      state.updateCandidateResponse = action?.payload?.message;
      state.updatingCandidateDetails = ApiStates.success;
    });
    builder.addCase(updateCandidateDetails.rejected, (state) => {
      state.updatingCandidateDetails = ApiStates.failed;
    });
    builder.addCase(fetchCandidateTraits.pending, (state) => {
        state.fetchingCandidateTraits = ApiStates.pending;
      });
      builder.addCase(fetchCandidateTraits.fulfilled, (state, action) => {
        console.log("API Response for Candidate Traits:", action.payload);
        state.candidateTraits = action?.payload?.data || [];
        state.fetchingCandidateTraits = ApiStates.success;
      });
      builder.addCase(fetchCandidateTraits.rejected, (state) => {
        console.log("API Response: Fetching Candidate Traits Failed");
        state.candidateTraits = [];
        state.fetchingCandidateTraits = ApiStates.failed;
      });

      builder.addCase(fetchCandidateAppliedJobs.pending, (state) => {
        state.fetchCandidateAppliedJobs = ApiStates.pending;
      });
      builder.addCase(fetchCandidateAppliedJobs.fulfilled, (state, action) => {
        console.log("API Response for Candidate Applied jobs:", action.payload);
        state.candidateAppliedJobs = action?.payload?.data || [];
        state.fetchCandidateAppliedJobs = ApiStates.success;
      });
      builder.addCase(fetchCandidateAppliedJobs.rejected, (state) => {
        console.log("API Response: Fetching Candidate Traits Failed");
        state.candidateAppliedJobs = [];
        state.fetchCandidateAppliedJobs = ApiStates.failed;
      });
  },
});
export const { resetCandidateUpdateState } = candidateDetailsSlice.actions;
export default candidateDetailsSlice;